
import React from "react";
import { UseFormReturn } from "react-hook-form";
import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

interface AccountBasicFieldsProps {
  form: UseFormReturn<any>;
}

const AccountBasicFields = ({ form }: AccountBasicFieldsProps) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <FormField
        control={form.control}
        name="external_id"
        render={({ field }) => (
          <FormItem>
            <FormLabel htmlFor="external_id">External ID</FormLabel>
            <FormControl>
              <Input 
                {...field} 
                id="external_id"
                placeholder="Enter external account ID" 
              />
            </FormControl>
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="exchange"
        render={({ field }) => (
          <FormItem>
            <FormLabel htmlFor="exchange">Exchange</FormLabel>
            <Select
              onValueChange={field.onChange}
              defaultValue={field.value}
            >
              <FormControl>
                <SelectTrigger id="exchange" name="exchange">
                  <SelectValue placeholder="Select exchange" />
                </SelectTrigger>
              </FormControl>
              <SelectContent>
                <SelectItem value="OKX">OKX</SelectItem>
                <SelectItem value="Bybit">Bybit</SelectItem>
                <SelectItem value="Bitget">Bitget</SelectItem>
                <SelectItem value="Phemex">Phemex</SelectItem>
              </SelectContent>
            </Select>
          </FormItem>
        )}
      />
    </div>
  );
};

export default AccountBasicFields;
